module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_c('p', [_c('span', {
    staticClass: "span-pink"
  }, [_vm._v("www.ralphandco.com |")]), _vm._v(" @ralphcreative")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "span-pink"
  }, [_vm._v("Ralph LONDON |")]), _vm._v(" 27-33 Bethnal Green Road, E1 6LA "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("|")]), _vm._v(" +44 (0)20 3006 6730 "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("|")]), _vm._v(" london@ralphandco.com\n      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("Ralph NEW YORK |")]), _vm._v(" 100 Lafayette St, Unit 401, NY, 10013 "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("|")]), _vm._v(" +1 (212) 226 2089 "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("|")]), _vm._v(" newyork@ralphandco.com\n      "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("Ralph LOS ANGELES |")]), _vm._v(" 100 Lafayette St, Unit 401, NY, 10013 "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("|")]), _vm._v(" +1 (212) 226 2089 "), _c('span', {
    staticClass: "span-pink"
  }, [_vm._v("|")]), _vm._v(" la@ralphandco.com")]), _vm._v(" "), _c('div', {
    staticClass: "footer-social"
  }, [_c('div', {
    staticClass: "footer-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/common/ralph_logo.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-social-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/common/social_linkedin.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-social-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/common/social_twitter.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-social-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/common/social_facebook.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-social-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/common/social_instagram.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-social-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/common/social_vimeo.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-band"
  }, [_c('div', {
    staticClass: "footer-band-color ralph-pink"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-band-color ralph-blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-band-color ralph-orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-band-color ralph-green"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-band-color ralph-yellow"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69cf176e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Footbar.vue
// module id = 31
// module chunks = 1